import {Show} from 'platform/foundation';

import {useState, ReactNode} from 'react';

import {TestIdProps} from 'shared/web';

import {AuditCategoryOfStructure} from '../../../types/AuditCategoryOfStructure';
import {ConditionDamagesContext} from '../hooks/useConditionDamagesContext';
import {AddAndEditDamage} from './AddAndEditDamage';

type DamageCategoryProps = {
  children: ReactNode;
};

export const DamageCategory = ({children, ...rest}: DamageCategoryProps & TestIdProps) => {
  const [lastOrderNumber, setLastOrderNumber] = useState<number>(0);
  const [_damageId, setDamageId] = useState<string | null>(null);
  const [isDamageDialogOpen, setIsDamageDialogOpen] = useState<boolean>(false);
  const [dialogDamageCategory, setDialogDamageCategory] = useState<AuditCategoryOfStructure | null>(
    null
  );

  const onAddDamage = (category: AuditCategoryOfStructure) => {
    setDamageId(null);
    if (category.id === dialogDamageCategory?.id) {
      setIsDamageDialogOpen(true);
      return;
    }
    setDialogDamageCategory(category);
    setIsDamageDialogOpen(true);
  };

  const onEditDamage = (category: AuditCategoryOfStructure, damageId: string) => {
    // Always sync the category — a damage can be relocated to a different part between opens,
    // so reopening the same damageId must still refresh the dialog's category (title, part
    // dropdown, and the fields it reads), not keep the previous one.
    setDamageId(damageId);
    setDialogDamageCategory(category);
    setIsDamageDialogOpen(true);
  };

  return (
    <ConditionDamagesContext.Provider
      value={{
        onAddDamage,
        onEditDamage,
        lastOrderNumber,
        setLastOrderNumber,
      }}
    >
      {children}

      <Show when={dialogDamageCategory}>
        {(dialogDamageCategory) => (
          <AddAndEditDamage
            isOpen={isDamageDialogOpen}
            onClose={() => {
              setIsDamageDialogOpen(false);
            }}
            category={dialogDamageCategory}
            damageId={_damageId}
            data-testid={rest['data-testid']}
          />
        )}
      </Show>
    </ConditionDamagesContext.Provider>
  );
};
